import { Instance } from 'mobx-state-tree';
import { ProjectRouteUpdatedDtoModelBase } from './ProjectRouteUpdatedDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteUpdatedDtoModel */
export interface ProjectRouteUpdatedDtoModelType extends Instance<typeof ProjectRouteUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteUpdatedDtoModel */
export { selectFromProjectRouteUpdatedDto, projectRouteUpdatedDtoModelPrimitives, ProjectRouteUpdatedDtoModelSelector } from './ProjectRouteUpdatedDtoModel.base';

/**
 * ProjectRouteUpdatedDtoModel
 */
export const ProjectRouteUpdatedDtoModel = ProjectRouteUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
